<template>
  <!-- SMP Invoice Template to mimic google sheet.  This is readonly, for printing/pdfing-->
  <div class="container print-area">
    <div class="header">
      <div>
        <h1>SMP-Services Corp.</h1>
        <h3 style="font-style: italic">GST # 84404 2291 RT0001</h3>
      </div>
      <div>
        <h1>INVOICE</h1>
      </div>
    </div>
    <div class="body">
      <div>
        <p>3036 2nd St SW</p>
        <p>Calgary, AB</p>
        <p>T2S 1T3</p>
        <p>Phone: (403) 605-7231</p>
      </div>

      <div>
        <h3>Date: {{ dateString }}</h3>
        <h3>Invoice # {{ invoiceId }}</h3>
        <p>{{ initials }}</p>
      </div>
    </div>
    <div class="footer">
      <div class="pb-3">
        <p>Bill to: {{ customer }}</p>
      </div>
      <div>
        <p>For: Engineering Services</p>
      </div>
      <div>
        <p>Location: {{ address }}</p>
      </div>
    </div>

    <table>
      <colgroup>
        <col class="desc-col"/>
        <col class="value-col"/>
      </colgroup>

      <thead>

        <tr>
          <th>Description</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <!--tr v-for="n in 6" :key="n"-->
        <tr v-for="(item, index) in lineItemsArr" :key="index">
          <td>{{ item.description }}</td>
          <td class="dollars">{{ item.value != '' ? '$ ' + item.value : '' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>{{ tax.name }} @ {{ taxRate }}</td>
          <td class="dollars">$ {{ taxTotal.toFixed(2) }}</td>
        </tr>
        <tr>
          <td class="bold">TOTAL:</td>
          <td class="bold dollars value-total">$ {{ (valueTotal + taxTotal).toFixed(2) }}</td>
        </tr>
      </tfoot>
    </table>

    <div class="bottom">
      <p>
        Please retain invoice for payment and internal record purposes as no statement will be
        issued for outstanding balances. Terms: net in 30 days, all amounts outstanding for greater
        than thirty days are charged interest at 1.5% per month (18% annually).
      </p>
      <p>
        Make all checks payable to <b>SMP-SERVICES CORP.</b> or send interact transfer to
        steve@smpwork.com and please use question: what is your last name? and use "petrovich" as
        the pass word for interact transfers
      </p>
      <p style="text-align: center; font-weight: bold">THANK YOU FOR YOUR BUSINESS!</p>
    </div>

    <!--div class="no-print">
            <button class="button" @click="printInvoice">Print</button>
        </div>-->

    <!--Table-->
    <!--<div class="border border-slate-700 col-span-3">
            Description
        </div>
        <div class="border border-slate-700 col-span-1">
            Amount
        </div>-->
    <!--line item descriptions-->
    <!--input v-for="n in rowCount" :key="n" type="text" v-model="lineItems[n].description" class="border border-slate-700 col-start-1 col-end-4 hover:bg-green-200">
    -->
    <!--
        <input v-for="(item, index) in lineItems" :key="index" :value="item.description" class="border border-slate-700 col-start-1 col-end-4 hover:bg-green-200">
    -->
    <!--div>
        <InvoiceTable :taxRate="taxRate"
        v-model:net-tax="taxTotal"
        v-model:net-value="valueTotal"
        v-model:lineItems="lineItems">
    </InvoiceTable>
    </div-->
  </div>

  <!--div class="debug">
        <p>SMP-invoice passed props :</p>
        <p>id = {{ invoiceId }}</p>
        <p>lineItems = {{ lineItems }}</p>
        <p>customer = {{ customer }}</p>
        <p>address = {{ address }}</p>
        <p>taxRate = {{ taxRate }}</p>
        <p>taxTotal = {{ taxTotal }}</p>
        <p>valueTotal = {{ valueTotal }}</p>
        
     </div>-->
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { formatDate } from '@/libs/utils'
//import InvoiceTable from './Lineitems-table.vue';
//import { TaxOptions } from '@/types/types';

const props = defineProps({
  invoiceId: String,
  lineItems: Array,
  customer: String,
  address: String,
  taxRate: Number,
  tax: Object,
  date: String,
  initials: String
  //taxTotal : Number,
  //valueTotal : Number
})
/*
    const taxName = computed(()=>{
        const prov = props.address.split(',')[2];
        if(prov == 'AB' || prov == 'BC' || prov == 'SK' || prov == 'MB'){
            return 'GST';
        }else{
            return 'HST';
        }
    })*/
const valueTotal = defineModel<Number | null>('valueTotal', { required: true })
const taxTotal = defineModel<Number>('taxTotal', { required: true })

//const valueTotal = ref(0);
const rowCount = 6
const lineItemsArr = computed(() => {
  const emptyItem = { description: '', value: '' }
  //let sum = 0;
  const padded = props.lineItems.map((item) => {
    let parsedItem = { description: item.description, value: item.value.toFixed(2) }
    //valueTotal.value += item.value;
    return parsedItem
  })
  for (let i = 0; i < rowCount; i++) {
    padded.push(emptyItem)
  }
  return padded
})

const dateString = computed(() => {
  //return new Date(props.date).toLocaleDateString();
  return formatDate(new Date(props.date))
})
//const date = ref('Nov 03, 2024');
//const date = new Date().toIsoString();  //TODO format
//const invNo = ref('20241-1001');
// const initials = ref('CG');
// const customer = ref('Joe Blow - Bustroff Inc.');
// const address = ref('800 Stupid St, Winnipeg, MB');

function printInvoice() {
  window.print()
}
</script>



<style lang="css" scoped>
@media print {
  .print-area {
    display: block;
    visibility: visible;
    color: brown;
    margin: 0;
    padding-top: 0;
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
  }
}

.print-area {
  padding: 2rem;
}

div.header,
div.body {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

table,
th,
tr,
td {
  border-collapse: collapse;
  /*border: 1px solid black;*/
}

table thead th,
table tbody tr td {
  border: 1px solid black;
}

table {
  width: 100%;
}

tbody {
  /*heavy border on bottom*/
  /*border-bottom: 1px solid blue;
     border-style: double;*/
}

tbody tr,
tfoot tr {
  height: 3rem;
  /*color: green;*/
}

.dollars {
  /*color: blue;*/
  text-align: right;
  padding-right: 1rem;
}

tbody tr td {
  padding-left: 1rem;
}

tfoot tr td {
  text-align: right;
  padding-right: 1rem;
}

th {
  padding: 0.5rem;
}

.bold {
  font-weight: 700;
}

td.value-total {
  background-color: lightyellow;
  border: 1px solid black;
}
col.desc-col{
  width: 80%;
}
col.value-col{
  width: 20%;
}
</style>
